'use strict';

function sanitizeURIComponent(obj) {
  // undefined, null, and NaN are represented as a blank string,
  // while false and 0 are stringified.
  return !obj && obj !== false && obj !== 0 ? '' : encodeURIComponent(obj);
}

module.exports = sanitizeURIComponent;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/object/internal/sanitizeURIComponent.js
// module id = 308
// module chunks = 0